// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 162 ? "65ab1394" : chunkId) + "." + {"162":"442249b77d298aac","862":"e27ffe190ed8de64"}[chunkId] + ".js";
};